/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import 'react-telephone-input/css/default.css';
import styles from '../authentication/components/login.module.scss';
import formstyles from '../../forms/forms.module.scss';

const ApplicationStatus = app => (
  <form name="loginForm" className={styles.login_form}>
  <div className={styles.login_form_wrapper}>
   <div className={styles.welcome} style={{ marginBottom: '50px', textAlign: 'center' }}>
    {app.item.status === 3 ? (
      <FormattedMessage id="badging.application.draft" defaultMessage="Your application has been saved as draft." />) : (
        <>
        {app.successMessage?.length > 0 && (
          <div dangerouslySetInnerHTML={{ __html: app.successMessage }} />
        )}
        {(app.successMessage?.length === 0 || !app.successMessage) && (
          <>
            <span className={formstyles.submitted_msg}>
            <FormattedMessage id="badging.application.status1" defaultMessage="Your application has been submitted successfully." />
            </span>
          </>
        )}
        </>
      )
    }
    {localStorage.removeItem('currentPage')}
   </div>
  </div>
  </form>
);


ApplicationStatus.propTypes = {
  app: PropTypes.number.isRequired
};

export default ApplicationStatus;
